export default __webpack_public_path__ + "static/media/about_image.708dcfa2.png";